import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import CurrencyFormat from 'react-currency-format';
import { DebounceInput } from 'react-debounce-input';

import Utils from '../../../Services/Utils';

import InputWrapper from '../WrapperInput';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

class InputCurrency extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      formatValue: null
    };
  }

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isNull(value)) {
      return 'This field is required.';
    }
    for (const validator of validators || []) {
      if (validator(value)) {
        return validator(value);
      }
    }
    return '';
  };

  handleChange = (e) => {
    const { onChange, onError, error } = this.props;
    const { formatValue } = this.state;
    this.setState({ value: e.target.value });
    const floatValue = !Utils.isNull(formatValue) && !Utils.isNull(formatValue.floatValue) ? formatValue.floatValue : null;
    const formattedValue = !Utils.isNull(formatValue) && !Utils.isNull(formatValue.formattedValue) ? formatValue.formattedValue : null;
    if (onChange) {
      onChange(floatValue);
    }
    const newError = this.validate(formattedValue);
    if (onError && !Utils.equals(newError, error)) {
      onError(newError);
    }
  };

  handleKeyDown = (e) => {
    const { onSubmit, value, min, max, maxlength } = this.props;
    const fractionSize = parseInt(this.props.fractionSize) || 2;
    if (e.keyCode !== 8) {
      if (e.keyCode === 13) {
        if (onSubmit) {
          onSubmit();
        }
        e.preventDefault();
      } else {
        const fraction = e.currentTarget.value.split('.');
        if (fraction.length > 1 && fraction[fraction.length - 1].length >= fractionSize) {
          e.preventDefault();
        }
        if (Number(value) > Number(max)) {
          e.preventDefault();
          e.currentTarget.value = max;
        }
        if (value && value.toString().length === maxlength) {
          e.preventDefault();
        }
        if (e.currentTarget.value && Number(value) < Number(min)) {
          e.preventDefault();
          e.currentTarget.value = min;
        }
      }
    }
  };

  render() {
    const { className, label, labelhtml, error, placeholder, disabled, required, value, debounce } = this.props;

    const debounceTimeout = !Utils.isNull(debounce) ? debounce : 1200;

    const symbol = this.props.symbol || '$';

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required
    };

    return (
      <InputWrapper {...WrapperProps}>
        <DebounceInput
          debounceTimeout={debounceTimeout}
          element={CurrencyFormat}
          value={!Utils.isNull(value) ? value : ''}
          thousandSeparator={true}
          decimalScale={2}
          prefix={symbol}
          onValueChange={(v) => this.setState({ formatValue: v })}
          disabled={disabled}
          required={required}
          onKeyDown={this.handleKeyDown}
          className={classNames('InputText', {
            InputText_Disabled: Boolean(disabled)
          })}
          placeholder={placeholder}
          onChange={this.handleChange}
        />
      </InputWrapper>
    );
  }
}

InputCurrency.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  min: PropTypes.number,
  maxlength: PropTypes.number,
  max: PropTypes.number,
  debounce: PropTypes.number,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func
};

export default withShallowComparison(InputCurrency, ['onChange', 'onError']);
